import React from 'react';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

const ArrowSortDown = (props) => <ArrowDownwardIcon {...props} />;

export default ArrowSortDown;
